import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var static_init_called;
function static_init() {
  if (static_init_called)
    return Unit_instance;
  static_init_called = true;
  CornerShape_Circular_instance = new (CornerShape())('Circular', 0);
  CornerShape_Continuous_instance = new (CornerShape())('Continuous', 1);
}
var CornerShape_Circular_instance;
var CornerShape_Continuous_instance;
var CornerShapeClass;
function CornerShape() {
  if (CornerShapeClass === VOID) {
    class $ extends Enum() {}
    initMetadataForClass($, 'CornerShape');
    CornerShapeClass = $;
  }
  return CornerShapeClass;
}
function CornerShape_Circular_getInstance() {
  static_init();
  return CornerShape_Circular_instance;
}
function CornerShape_Continuous_getInstance() {
  static_init();
  return CornerShape_Continuous_instance;
}
//region block: exports
export {
  CornerShape_Circular_getInstance as CornerShape_Circular_getInstance1fe8iru495tm6,
  CornerShape_Continuous_getInstance as CornerShape_Continuous_getInstancexm3mpluosqyq,
};
//endregion

//# sourceMappingURL=CornerShape.mjs.map
